import { Alert, Paper } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslate } from "react-admin";

import { LearningBlock } from "../../../lib/learning/contentContract";
import { borderRadius, color, shadows, space } from "../../../theme/designTokens";
import { DialogueBlock } from "./DialogueBlock";
import { FlipCardsBlock } from "./FlipCardsBlock";
import { GalleryBlock } from "./GalleryBlock";
import { MatchingBlock } from "./MatchingBlock";
import { TemplateBlock } from "./TemplateBlock";
import { VideoBlock } from "./VideoBlock";

export const BlockRenderer = ({ block }: { block: LearningBlock }) => {
  const translate = useTranslate();
  let content: ReactNode;
  switch (block.type) {
    case "template":
      content = <TemplateBlock page={block.page} />;
      break;
    case "video":
      content = <VideoBlock title={block.title} video={block.video} thumbnail={block.thumbnail} />;
      break;
    case "gallery":
      content = <GalleryBlock title={block.title} photos={block.photos} />;
      break;
    case "flipCards":
      content = <FlipCardsBlock cards={block.cards} />;
      break;
    case "dialogue":
      content = <DialogueBlock steps={block.steps} autoAdvanceMs={block.autoAdvanceMs} />;
      break;
    case "matching":
      content = <MatchingBlock pairs={block.pairs} />;
      break;
    default:
      content = <Alert severity="warning">{translate("learning.player.unsupportedBlock")}</Alert>;
  }
  return (
    <Paper
      component="section"
      data-testid={`learning-block-${block.id}`}
      variant="outlined"
      sx={{
        p: { xs: space.xl, md: space.xxl1 },
        borderRadius: borderRadius.md,
        borderColor: color.panelBorder,
        boxShadow: shadows.card,
      }}
    >
      {content}
    </Paper>
  );
};
